import script from "./recently-viewed.vue?vue&type=script&setup=props&lang=js"
export * from "./recently-viewed.vue?vue&type=script&setup=props&lang=js"

const __exports__ = script;

export default __exports__